import React from "react";
import { Box, TextField, FormControl, InputLabel, Select, MenuItem } from "@material-ui/core";
import { BooleanRadioGroup } from "./BooleanRadioGroup";

interface DeliverySettingsSectionProps {
  isContactPersonRequired: boolean | undefined;
  setIsContactPersonRequired: (value: boolean) => void;
  isGpsAccurate: boolean | undefined;
  setIsGpsAccurate: (value: boolean) => void;
  gpsInaccurateDescription: string;
  setGpsInaccurateDescription: (value: string) => void;
  isGatedProperty: boolean | undefined;
  setIsGatedProperty: (value: boolean) => void;
  gatedPropertyDetails: string;
  setGatedPropertyDetails: (value: string) => void;
  tankConnectionDetails: string;
  setTankConnectionDetails: (value: string) => void;
  tankDistance: string;
  setTankDistance: (value: string) => void;
  services: { name: string; default: boolean }[];
  setService: (value: string) => void;
  service: string;
}

export const DeliverySettingsSection: React.FC<DeliverySettingsSectionProps> = ({
  isContactPersonRequired,
  setIsContactPersonRequired,
  isGpsAccurate,
  setIsGpsAccurate,
  gpsInaccurateDescription,
  setGpsInaccurateDescription,
  isGatedProperty,
  setIsGatedProperty,
  gatedPropertyDetails,
  setGatedPropertyDetails,
  tankConnectionDetails,
  setTankConnectionDetails,
  tankDistance,
  setTankDistance,
  services,
  setService,
  service,
}) => {
  return (
    <Box display="flex" flexDirection="column">
      <Box mb={2}>
        <BooleanRadioGroup
          label="Does someone need to be present at the time of service?"
          value={isContactPersonRequired}
          onChange={setIsContactPersonRequired}
        />
      </Box>

      <Box mb={2}>
        <BooleanRadioGroup
          label="Does GPS take us directly to the service location?"
          value={isGpsAccurate}
          onChange={setIsGpsAccurate}
        />
      </Box>

      {isGpsAccurate === false && (
        <Box mb={2}>
          <TextField
            fullWidth
            label="Please provide GPS coordinates and/or directions."
            value={gpsInaccurateDescription}
            onChange={(e) => setGpsInaccurateDescription(e.target.value)}
            margin="normal"
            multiline
            rows={3}
          />
        </Box>
      )}

      <Box mb={2}>
        <BooleanRadioGroup
          label="Do we need to enter a gated property?"
          value={isGatedProperty}
          onChange={setIsGatedProperty}
        />
      </Box>

      {isGatedProperty === true && (
        <Box mb={2}>
          <TextField
            fullWidth
            label="Please provide any info we'll need to enter the property. i.e. gate codes, padlock combos, etc..."
            value={gatedPropertyDetails}
            onChange={(e) => setGatedPropertyDetails(e.target.value)}
            margin="normal"
            multiline
            rows={3}
          />
        </Box>
      )}

      <Box mb={2}>
        <TextField
          fullWidth
          label="How do we connect to the tank? i.e. hydrant, valve, top hole..."
          value={tankConnectionDetails}
          onChange={(e) => setTankConnectionDetails(e.target.value)}
          margin="normal"
          multiline
          rows={3}
        />
      </Box>

      <Box mb={2}>
        <TextField
          fullWidth
          label="How close can we get to the fill spot (hydrant, tank, pool, etc.)?"
          value={tankDistance}
          onChange={(e) => setTankDistance(e.target.value)}
          margin="normal"
        />
      </Box>

      {/* Services dropdown */}
      <Box mb={2}>
        <FormControl fullWidth>
          <InputLabel>Services</InputLabel>
          <Select
            value={service}
            onChange={(e) => setService(e.target.value as string)}
            label="Services"
          >
            <MenuItem value="">Select Service</MenuItem>
            {services.map((serviceItem) => (
              <MenuItem key={serviceItem.name} value={serviceItem.name}>
                {serviceItem.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
    </Box>
  );
};

